import React, {useState} from 'react';
import './Header.scss';
import logo from '../../images/logo.svg'
import avatar from '../../images/image-avatar.png'
import cart from '../../images/icon-cart.svg'
import {Popup} from "./popup";
import art1 from "../../images/image-product-1.jpg";
import {RiDeleteBin6Fill} from "react-icons/ri"

import {CountContext} from "../../CountContext";
import {useContext} from "react";

export function Header() {
    const [buttonPopup, setButtonPopup] = useState(false);

    const {count, setCount} = useContext(CountContext)
    const price = 125;

    return(
        <>
        <div className="header">
            <div className="logo">
                <img src={logo} alt="logo"/>
            </div>

            <div className="links">
                <ul>
                    <a href="">Collections</a>
                    <a href="">Men</a>
                    <a href="">Women</a>
                    <a href="">About</a>
                    <a href="">Contact</a>
                </ul>
            </div>

            <div className="header-buttons">
                <div className="caddie">
                    <img src={cart} alt="caddie" onClick={() => setButtonPopup(true)}/>
                    <span className="notif">{count}</span>

                    <Popup trigger={buttonPopup} setTrigger={setButtonPopup} >
                        {count > 0 ?
                            <div className="purchase">
                                <div className="purchase-content">
                                    <img src={art1} alt="purchase" />
                                    <p>Fall Limited Edition Sneakers<br></br>
                                        <span>${price}.00 * {count} <span className="result">${count * price}.00</span></span>

                                    </p>


                                    <a href="" onClick={() => setCount(0)} className="bin"> <RiDeleteBin6Fill /></a>

                                </div>
                                <button>Checkout</button>

                            </div>
                            : 'Your cart is empty.'}
                    </Popup>
                </div>
                <div>
                    <img src={avatar} alt="avatar" className="avatar" />
                </div>
            </div>

        </div>
            <div className="border-bottom"></div>
        </>
    )
}
